
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/match/request",
      function () {
        return require("private-next-pages/match/request.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/match/request"])
      });
    }
  